/* RareTCG appearance controller — explicit Light / System / Dark choice.
   The legacy desktop segmented button remains a binary convenience control;
   the mobile Shop drawer exposes all three choices. */
(() => {
  'use strict';

  const KEY = 'rtcg-skin';
  const LIGHT = 'rtcg-theme-light';
  const DARK = 'rtcg-theme-dark';
  const media = window.matchMedia('(prefers-color-scheme: dark)');

  const resolved = () => (document.body.classList.contains(LIGHT) ? 'light' : 'dark');
  const stored = () => {
    try {
      const value = localStorage.getItem(KEY);
      return ['light', 'dark', 'system'].includes(value) ? value : null;
    } catch (_) { return null; }
  };
  const resolveChoice = choice => choice === 'system' ? (media.matches ? 'dark' : 'light') : choice;

  function syncControls(choice = stored()) {
    const effective = resolved();
    document.querySelectorAll('[data-rtcg-skin-toggle]').forEach(btn => {
      btn.setAttribute('aria-pressed', effective === 'light' ? 'true' : 'false');
    });
    document.querySelectorAll('[data-rtcg-skin-value]').forEach(btn => {
      const value = btn.getAttribute('data-rtcg-skin-value');
      const active = choice ? value === choice : value === effective;
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  function applyChoice(choice, persist = true) {
    if (!['light', 'dark', 'system'].includes(choice)) return;
    const skin = resolveChoice(choice);
    document.body.classList.remove(LIGHT, DARK);
    document.body.classList.add('rtcg-theme-' + skin);
    document.body.dataset.rtcgSkinChoice = choice;
    if (persist) {
      try { localStorage.setItem(KEY, choice); } catch (_) { /* private mode */ }
    }
    syncControls(choice);
    document.dispatchEvent(new CustomEvent('rtcg:skin-change', { detail: { skin, choice } }));
  }

  function init() {
    const choice = stored();
    if (choice) applyChoice(choice, false);
    else syncControls(null);

    document.querySelectorAll('[data-rtcg-skin-toggle]').forEach(btn => {
      if (btn.dataset.rtcgSkinReady === 'true') return;
      btn.dataset.rtcgSkinReady = 'true';
      btn.addEventListener('click', () => applyChoice(resolved() === 'light' ? 'dark' : 'light'));
    });
    document.querySelectorAll('[data-rtcg-skin-value]').forEach(btn => {
      if (btn.dataset.rtcgSkinReady === 'true') return;
      btn.dataset.rtcgSkinReady = 'true';
      btn.addEventListener('click', () => applyChoice(btn.getAttribute('data-rtcg-skin-value')));
    });
  }

  const onSystemChange = () => {
    if (stored() === 'system') applyChoice('system', false);
  };
  if (typeof media.addEventListener === 'function') media.addEventListener('change', onSystemChange);
  else if (typeof media.addListener === 'function') media.addListener(onSystemChange);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
